import { render, staticRenderFns } from "./KitchenRulePanel.vue?vue&type=template&id=6a685838&"
import script from "./KitchenRulePanel.vue?vue&type=script&lang=js&"
export * from "./KitchenRulePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports